export * from './stat/stat.module';
export * from './page-header/page-header.module';
export * from './shared.module';



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/modules/index.ts